'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildRechargeCheckoutUrl;
/**
 * Build ReCharge Checkout URL
 *
 * @param   string   cartToken           - The current cart token from shopify.
 *
 * @return  string   rechargeCheckoutUrl - The checkout url to ReCharges custom checkout.
 */

function buildRechargeCheckoutUrl(cartToken) {
  // Shopify Domain
  var shopifyDomain = window.theme.shopifyDomain;

  // GA Param
  var gaLinker = '';
  if (window.ga && window.ga.getAll() && window.ga.getAll()[0]) {
    gaLinker = ga.getAll()[0].get('linkerParam');
  }

  // Customer
  var customerParam = '';
  if (window.theme.customer) {
    customerParam = customerParam + ' customer_id=' + window.theme.customerId + '&customer_email=' + window.theme.customerEmail;
  }

  // Checkout URL
  var rechargeCheckoutUrl = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + shopifyDomain + '&cart_token=' + cartToken + '&' + gaLinker + '&' + customerParam;

  return rechargeCheckoutUrl;
}